import { FATCATaxResidencyEntry } from '../utils/useFATCATaxResidencies';
import { mockReasonsForTinMissing } from './mockVariablesForValues';

export const validateFATCATaxResidenciesReasons = async (
  fatcaTaxResidencies: FATCATaxResidencyEntry[],
): Promise<{ status: string; entries: FATCATaxResidencyEntry[] }> => {
  console.info('Validating FATCA tax residencies reasons...');

  console.info(JSON.stringify(fatcaTaxResidencies, null, 2));

  await new Promise<void>((resolve, _reject) => {
    setTimeout(() => {
      resolve();
    }, 1000);
  });

  const foundEntryRequiringTextReason = fatcaTaxResidencies.find(
    (item) =>
      'tinAbsentSelectedReason' in item &&
      item.tinAbsentSelectedReason === mockReasonsForTinMissing[1].value,
  );

  if (foundEntryRequiringTextReason) {
    if (
      !('tinAbsentTextReason' in foundEntryRequiringTextReason) ||
      !foundEntryRequiringTextReason.tinAbsentTextReason
    ) {
      return {
        status: 'incomplete',
        entries: fatcaTaxResidencies.map((entry) => {
          if (entry.id === foundEntryRequiringTextReason.id) {
            return {
              ...entry,
              tinAbsentTextReason: '',
              tinAbsentTextReasonRequired: true,
            };
          }

          return entry;
        }),
      };
    }
  }

  return { status: 'success', entries: fatcaTaxResidencies };
};
